<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="isShow"
      width="30%"
      :before-close="handleClose"
      center
      @open="openFn"
    >
      <div class="content">
        <div>
          <PassWordInput
          ref="PassWordInput"
          @inputFinish="inputFinish"
          class="password-box"
          ></PassWordInput>
          <el-button type="text" v-if="forget" class="forget-pw" @click="handleForget">忘记密码</el-button>
          <div v-if="tip" style="color: red;">{{ tip }}</div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="submit" :disabled="istrue">确定</el-button>
      </div>
    </el-dialog>

    <!-- 忘记密码弹窗 -->
    <FindPassword ref="findPwdRef"/>
  </div>
</template>

<script>

export default {
  data() {
    return {
      password: "",
      tip: "",
      istrue: false,
    };
  },
  props: {
    isShow: {
      type: Boolean,
    },
    title: {
      type: String,
      default: "输入密码",
    },
    config: {
      typeof: Object,
    },
    forget: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PassWordInput: () => import("./PassWordInput.vue"),
    FindPassword: () => import("./FindPassword.vue"),
  },
  methods: {
    openFn(){
      if (this.$refs.PassWordInput) {
        this.$refs.PassWordInput.msg = "";
      }
      this.tip = "";
    },
    handleForget(){
      this.$emit("close");
      this.$refs.findPwdRef.openDialog();
    },
    clearPassword() {
      this.$refs.PassWordInput.msg = "";
    },
    handleClose() {
      this.$refs.PassWordInput.msg = "";
      this.tip = "";
      this.$emit("close");
    },
    inputFinish(e) {
      this.password = e;
    },
    submit() {
      if (this.password.length < 6) {
        this.tip = "请输入密码";
        return;
      }
      this.$emit("personnelStructure",this.password)
      this.$emit("submits",this.password)
      this.handleClose();
      this.$emit("submit", this.password);
      this.istrue = true;
      setTimeout(() => {
        this.istrue = false;
        this.$refs.PassWordInput.msg = "";
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  .password-box {
    text-align: center;
    position: relative;
  }
  .forget-pw {
    position: absolute;
    top: 67px;
    right: 86px;
  }
  .el-button {
    margin-top: 20px;
  }
}
</style>